// start:ng42.barrel
import './faria-one.component';
// end:ng42.barrel

